function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.2227 29.0314C34.5893 25.9843 35.9985 22.1565 35.9985 17.9995C35.9985 13.8426 34.5894 10.0149 32.2228 6.96781C32.5543 6.93796 32.89 6.92271 33.2292 6.92271C39.3468 6.92271 44.3061 11.882 44.3061 17.9996C44.3061 24.1172 39.3468 29.0765 33.2292 29.0765C32.8899 29.0765 32.5542 29.0613 32.2227 29.0314Z",
  fill: "url(#paint0_linear_23_1310)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.2227 29.0318C34.5894 25.9847 35.9985 22.1569 35.9985 17.9999C35.9985 13.843 34.5894 10.0153 32.2229 6.96823C26.5769 7.4767 22.1523 12.2217 22.1523 18C22.1523 23.7783 26.5768 28.5233 32.2227 29.0318Z",
  fill: "url(#paint1_linear_23_1310)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.2243 6.96826C26.5783 7.47676 22.1538 12.2217 22.1538 18.0001C22.1538 23.7784 26.5783 28.5233 32.2242 29.0319C28.9311 33.2717 23.7842 36 18 36C8.05888 36 0 27.9411 0 18C0 8.05887 8.05888 0 18 0C23.7842 0 28.9312 2.72832 32.2243 6.96826Z",
  fill: "url(#paint2_linear_23_1310)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59.215 24.3578L67.9641 8.25135V7.40364H52.7969V11.6725H61.1525L52.3125 27.9303V28.5964H68.3274V24.3578H59.215Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M76.1686 24.3578V19.9982H83.5252V15.8505H76.1686V11.6422H84.3123V7.40364H71.5972V28.5964H84.6453V24.3578H76.1686Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M100.164 28.5964H105.28L100.587 20.6037C102.949 19.4532 104.462 17.2128 104.462 14.4275C104.462 10.3403 101.284 7.40364 97.0453 7.40364H88.5081V28.5964H93.0794V21.3908H96.016L100.164 28.5964ZM93.0794 11.6422H96.7426C98.6801 11.6422 99.8003 12.8229 99.8003 14.3972C99.8003 16.0018 98.6801 17.1523 96.7426 17.1523H93.0794V11.6422Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M118.397 29.0808C124.845 29.0808 129.659 24.3275 129.659 18C129.659 11.7027 124.845 6.94951 118.397 6.94951C111.918 6.94951 107.074 11.733 107.074 18C107.074 24.2973 111.918 29.0808 118.397 29.0808ZM118.397 24.7514C114.612 24.7514 111.736 21.8147 111.736 18C111.736 14.1853 114.612 11.2789 118.397 11.2789C122.181 11.2789 124.996 14.155 124.996 18C124.996 21.845 122.181 24.7514 118.397 24.7514Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M138.034 24.3578L146.783 8.25135V7.40364H131.616V11.6725H139.971L131.131 27.9303V28.5964H147.146V24.3578H138.034Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M154.987 24.3578V19.9982H162.344V15.8505H154.987V11.6422H163.131V7.40364H150.416V28.5964H163.464V24.3578H154.987Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M178.982 28.5964H184.099L179.406 20.6037C181.767 19.4532 183.281 17.2128 183.281 14.4275C183.281 10.3403 180.102 7.40364 175.864 7.40364H167.327V28.5964H171.898V21.3908H174.835L178.982 28.5964ZM171.898 11.6422H175.561C177.499 11.6422 178.619 12.8229 178.619 14.3972C178.619 16.0018 177.499 17.1523 175.561 17.1523H171.898V11.6422Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M197.215 29.0808C203.664 29.0808 208.477 24.3275 208.477 18C208.477 11.7027 203.664 6.94951 197.215 6.94951C190.737 6.94951 185.893 11.733 185.893 18C185.893 24.2973 190.737 29.0808 197.215 29.0808ZM197.215 24.7514C193.431 24.7514 190.555 21.8147 190.555 18C190.555 14.1853 193.431 11.2789 197.215 11.2789C201 11.2789 203.815 14.155 203.815 18C203.815 21.845 201 24.7514 197.215 24.7514Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M216.605 6.72899C216.605 6.0205 217.181 5.44615 217.89 5.44615H271.259C271.969 5.44615 272.544 6.0205 272.544 6.72899V29.1787C272.544 29.8872 271.969 30.4615 271.259 30.4615H217.89C217.181 30.4615 216.605 29.8872 216.605 29.1787V6.72899Z",
  fill: "#FF4F00"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M227.429 22.3296V10.5839H224.258V25.266H233.078V22.3296H227.429Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M235.23 25.266H238.401V10.5839H235.23V25.266Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M251.097 10.5839L247.485 20.9663L243.767 10.5839H240.26L245.994 25.266H248.997L254.562 10.5839H251.097Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M259.689 22.3296V19.3093H264.793V16.4358H259.689V13.5203H265.339V10.5839H256.518V25.266H265.57V22.3296H259.689Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_23_1310",
  x1: 32.2322,
  y1: 6.92271,
  x2: 32.2322,
  y2: 29.0765,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5BC2E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_23_1310",
  x1: 25.2816,
  y1: 10.4262,
  x2: 32.4539,
  y2: 29.0216,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9DDAF1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_23_1310",
  x1: 6.8677,
  y1: 4.88769,
  x2: 26.8062,
  y2: 33.7154,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBAC13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45223,
  stopColor: "#FF4F00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4F00"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 36,
    viewBox: "0 0 273 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.5e293a91.svg";
export { ForwardRef as ReactComponent };